import React, { useContext, useEffect, useState } from "react";
import FiltersContext from "../../../../contexts/filtering";
import TransitionStatistics from "./Transitions";
import TrendStatistics from "./Trend";
import WaterSurfaceStatistics from "./WaterSurface";
import WaterSurfaceClassificationStatistics from "./WaterSurfaceClassification";

export default function Statistics() {
  const {
    values,
    options: { analysisOptions },
  } = useContext(FiltersContext);
  const [statistics, setStatistics] = useState(<></>);

  useEffect(() => {
    if (values.analysis === analysisOptions.transition?.key) {
      setStatistics(<TransitionStatistics />);
    } else if (values.analysis === analysisOptions.trend?.key) {
      setStatistics(<TrendStatistics />);
    } else if (values.analysis === analysisOptions.surface?.key) {
      setStatistics(<WaterSurfaceStatistics />);
    } else if (values.analysis === analysisOptions.waterClassification?.key) {
      setStatistics(<WaterSurfaceClassificationStatistics />);
    } else {
      setStatistics(<></>);
    }
  }, [values.analysis]);

  return statistics;
}
